// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const TransactionSectionTitle = styled.h3`
	background: ${colors.lightGrey};
	color: ${colors.darkGrey};
	font-size: 18px;
	font-weight: bold;
	line-height: 1.5;
	height: 40px;
	padding: 5px 19px;
	display: flex;
	align-items: center;
	margin-bottom: 1px;
`;
export default TransactionSectionTitle;


// WEBPACK FOOTER //
// ./src/pages/league/transactions/transactionSectionTitle.js